import { type ArtifactMetaDataResponse, type ArtifactMintSteps } from '@app/client/common/structs/nft/artifacts';
import {
    type ArtifactBreakdownResponse,
    type ArtifactCount,
    type ArtifactKeys,
    type ArtifactMintDisplayItem,
    type ArtifactsResponse,
    type LootBoxTokenIdMapping,
} from '@app/store/types/artifacts';

export const SET_ARTIFACTS = 'SET_ARTIFACTS';
export const SET_ARTIFACT_KEYS = 'SET_ARTIFACT_KEYS';
export const SET_USER_ARTIFACTS = 'SET_USER_ARTIFACTS';
export const SET_ARTIFACTS_METADATA = 'SET_ARTIFACTS_METADATA';
export const SET_ARTIFACTS_BREAKDOWN = 'SET_ARTIFACTS_BREAKDOWN';
export const SET_ARTIFACT_TOTAL_COUNTS = 'SET_ARTIFACT_TOTAL_COUNTS';
export const SET_LOOT_BOX_TOKEN_ID_MAPPING = 'SET_LOOT_BOX_TOKEN_ID_MAPPING';
export const ACTION_ARTIFACT_MINT_PANEL_STEP = 'ACTION_ARTIFACT_MINT_PANEL_STEP';
export const ACTION_SET_ARTIFACT_MINT_PANEL_OPEN = 'ACTION_SET_ARTIFACT_MINT_PANEL_OPEN';
export const SET_SELECTED_ARTIFACT_MINT_DISPLAY = 'SET_SELECTED_ARTIFACT_MINT_DISPLAY';

export interface ArtifactsState {
    keys: ArtifactKeys;
    totalCounts: ArtifactCount;
    syncedArtifactIds: string[];
    artifactMintPanelOpen: boolean;
    artifacts: ArtifactsResponse | null;
    artifactMintPanelStep: ArtifactMintSteps | null;
    userArtifacts?: ArtifactBreakdownResponse | null;
    selectedArtifact: ArtifactMintDisplayItem | null;
    lootboxTokenIdMapping: LootBoxTokenIdMapping | null;
    artifactMetadata: ArtifactMetaDataResponse[] | null;
    artifactsBreakdown: ArtifactBreakdownResponse | null;
}

interface SetArtifacts {
    type: typeof SET_ARTIFACTS;
    artifacts: ArtifactsResponse;
}
interface SetUserArtifacts {
    type: typeof SET_USER_ARTIFACTS;
    userArtifacts: ArtifactBreakdownResponse;
}

interface SetArtifactsMetadata {
    type: typeof SET_ARTIFACTS_METADATA;
    artifactMetadata: ArtifactMetaDataResponse[];
}

interface SetArtifactKeys {
    type: typeof SET_ARTIFACT_KEYS;
    keys: ArtifactKeys;
}

interface SetTotalCounts {
    type: typeof SET_ARTIFACT_TOTAL_COUNTS;
    totalCounts: ArtifactCount;
}

interface SetLootBoxTokenIdMapping {
    type: typeof SET_LOOT_BOX_TOKEN_ID_MAPPING;
    lootboxTokenIdMapping: LootBoxTokenIdMapping;
}

interface SetArtifactMintPanelOpen {
    type: typeof ACTION_SET_ARTIFACT_MINT_PANEL_OPEN;
    artifactMintPanelOpen: boolean;
}

interface SetArtifactMintPanelStep {
    type: typeof ACTION_ARTIFACT_MINT_PANEL_STEP;
    artifactMintPanelStep: ArtifactMintSteps | null;
}

interface SetSelectedArtifactMintDisplay {
    type: typeof SET_SELECTED_ARTIFACT_MINT_DISPLAY;
    selectedArtifact: ArtifactMintDisplayItem | null;
}

interface SetArtifactBreakdown {
    type: typeof SET_ARTIFACTS_BREAKDOWN;
    artifactsBreakdown: ArtifactBreakdownResponse;
}

export type ArtifactsAction =
    | SetSelectedArtifactMintDisplay
    | SetLootBoxTokenIdMapping
    | SetArtifactMintPanelOpen
    | SetArtifactMintPanelStep
    | SetArtifactsMetadata
    | SetArtifactBreakdown
    | SetUserArtifacts
    | SetArtifactKeys
    | SetTotalCounts
    | SetArtifacts;
